import React, { Component, Fragment } from "react";
import * as registercorrectionservice from "../../services/register_correction/register-correction-service";
import * as validation from "../../utils/validations";
import * as Loader from "../../common/common";
import { validateEntitlement } from "../../common/validate-entitlement";
import { FUNCTIONALITY, ENTITLEMENTS } from "../../common/const";
import { Authorize } from "../../components/authorize";
import DataTable from "../../components/data-table";
import DropDown from "../../components/form-controls/dropdown";
import { ddUsersTypess } from "../../common/const";

class RegisterCorrection extends Authorize {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onClear = this.onClear.bind(this);
    this.clientCount = -1;
  }
  state = {
    client: {
      companyName: "",
      email: "",
      panNo: "",
      mobile: "",
      userType: "",
    },
    updatedClient: {},
    search: {
      companyNames: "",
      emails: "",
      pan: "",
      mobiles: "",
    },
    isUserType: false,

    headers: [
      {
        title: "Name",
        accessor: "companyName",
        index: 1,
        dataType: "string",
      },
      { title: "PAN", accessor: "panNo", index: 2, dataType: "string" },
      { title: "Email", accessor: "email", index: 3, dataType: "string" },
      {
        title: "Mobile",
        accessor: "mobile",
        index: 4,
        dataType: "string",
      },
      {
        title: "User Type",
        accessor: "userType",
        index: 5,
        dataType: "string",
      },

      {
        title: "Action",
        accessor: "id",
        index: 7,
        cell: (row) => {
          return (
            <div className="btn-group  float-right">
              {validateEntitlement(
                FUNCTIONALITY.searchUsers,
                ENTITLEMENTS.edit
              ) ? (
                <button
                  title="Edit"
                  type="button"
                  onClick={this.onEdit.bind(this, row.userId)}
                  className="btn btn-sm btn-primary fas fa-edit rounded-0"
                />
              ) : null}
              <span>&nbsp;</span>
              {row.userVerified ? (
                ""
              ) : (
                <button
                  className="btn btn-success  rounded-0"
                  onClick={() =>
                    this.increaseToken(this, row.userId, row.email)
                  }
                >
                  Resend Verification Link{" "}
                </button>
              )}
            </div>
          );
        },
      },
    ],
    data: [],
    loading: false,
    message: "",
    error: "",
    validationErrors: {},
    dropdownHidden: true,
    allCompanyDropdown: [],
    showModel: false,
  };

  handleInputChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (name === "companyName") {
      if (value && !validation.isValidcompanyName(value)) {
        validationErrors.companyNameError =
          "Name can only contain alphabets and space";
      } else {
        validationErrors.companyNameError = "";
      }
    }
    if (name === "email") {
      if (value && !validation.isValidEmail(value)) {
        validationErrors.emailError = "Please enter valid email";
      } else {
        validationErrors.emailError = "";
      }
    }
    if (name === "panNo") {
      if (value && !validation.isValidPAN(value)) {
        validationErrors.panNoError = "Please enter valid pan number";
      } else {
        validationErrors.panNoError = "";
      }
    }

    if (name === "mobile") {
      if (value && !validation.isValidMobile(value)) {
        validationErrors.mobileError = "Please enter valid MOBILE number";
      } else {
        validationErrors.mobileError = "";
      }
    }

    // if (name === "userType") {
    //   if (value && !validation.isValidMobile(value)) {
    //     validationErrors.userTypeError = "Please select valid UserType";
    //   } else {
    //     validationErrors.userTypeError = "";
    //   }
    // }

    if (name === "companyName" || name === "panNo") {
      this.setState({
        client: {
          ...this.state.client,
          [name]: value.toUpperCase(),
        },
        updatedClient: {
          ...this.state.updatedClient,
          [name]: value.toUpperCase(),
        },
        validationErrors: validationErrors,
        message: "",
      });
    } else if (name === "userType") {
      {
        this.setState({
          client: {
            ...this.state.client,
            [name]: value,
          },
          // updatedClient: {
          //   ...this.state.updatedClient,
          //   [name]: value,
          // },
          validationErrors: validationErrors,
          message: "",
          isUserType: true,
        });
      }
    } else if (name === "mobile") {
      {
        this.setState({
          client: {
            ...this.state.client,
            [name]: value,
          },
          validationErrors: validationErrors,
          message: "",
        });
      }
    } else {
      {
        this.setState({
          client: {
            ...this.state.client,
            [name]: value,
          },
          updatedClient: {
            ...this.state.updatedClient,
            [name]: value,
          },
          validationErrors: validationErrors,
          message: "",
        });
      }
    }
  }

  handleSearchInputChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    let validationErrors = Object.assign({}, this.state.validationErrors);

    if (name === "companyNames") {
      if (value && !validation.isValidcompanyName(value)) {
        validationErrors.companyNameError =
          "Name can only contain alphabets and space";
      } else {
        validationErrors.companyNameError = "";
        this.createDropdownList(value);
      }
    }

    if (name === "emails") {
      if (value && !validation.isValidEmail(value)) {
        validationErrors.emailError = "Please enter valid email";
      } else {
        validationErrors.emailError = "";
      }
    }

    if (name === "mobiles") {
      if (value && !validation.isValidMobile(value)) {
        validationErrors.mobileError = "Please enter valid mobile";
      } else {
        validationErrors.mobileError = "";
      }
    }

    if (name === "pan") {
      if (value && !validation.isValidPAN(value)) {
        validationErrors.panError = "Please enter valid pan";
      } else {
        validationErrors.panError = "";
      }
    }

    // if (name === "userType") {
    //   if (value && !validation.isValidPAN(value)) {
    //     validationErrors.panError = "Please enter valid pan";
    //   } else {
    //     validationErrors.panError = "";
    //   }
    // }

    if (name === "companyNames" || name === "pan") {
      this.setState({
        search: {
          ...this.state.search,
          [name]: value.toUpperCase(),
        },
        message: "",
        validationErrors: validationErrors,
      });
    } else {
      this.setState({
        search: {
          ...this.state.search,
          [name]: value,
        },
        message: "",
        validationErrors: validationErrors,
      });
    }
  }

  onEdit(userId, e) {
    let editData = Object.assign([], this.state.data);

    let newArray = editData.filter(function (el) {
      return el.userId === userId;
    });

    this.setState({
      client: newArray[0],
      data: newArray[0],
      error: "",
      message: "",
      showModel: !this.state.showModel,
    });
  }

  validateFields() {
    let { companyName, email, panNo, mobile } = this.state.client;
    let { companyNames, emails } = this.state.search;
    let checkValidation = true;
    let validationErrors = Object.assign({}, this.state.validationErrors);
    if (companyName && !validation.isValidcompanyName(companyName)) {
      validationErrors.companyNameError =
        "Name can only contain alphabets and space";
      checkValidation = false;
    }
    if (email && !validation.isValidEmail(email)) {
      validationErrors.emailError = "Please enter valid email";
      checkValidation = false;
    }

    if (panNo && !validation.isValidPAN(panNo)) {
      validationErrors.panError = "Please enter valid pan number";
      checkValidation = false;
    }

    if (mobile && !validation.isValidMobile(mobile)) {
      validationErrors.mobileError = "Please enter valid MOBILE number";
      checkValidation = false;
    }

    if (companyNames && !validation.isValidcompanyName(companyNames)) {
      validationErrors.companyNameError =
        "Name can only contain alphabets and space";
      checkValidation = false;
    }

    if (emails && !validation.isValidEmail(emails)) {
      validationErrors.emailError = "Please enter valid email";
      checkValidation = false;
    }

    this.setState({
      validationErrors: validationErrors,
    });
    return checkValidation;
  }

  async onSearch() {
    let user = {
      companyNames: this.state.search.companyNames,
      emails: this.state.search.emails,
      pan: this.state.search.pan,
      mobiles: this.state.search.mobiles,
    };

    Loader.showLoader();
    let allowSearch = this.validateFields();
    if (allowSearch) {
      let { response, err } = await registercorrectionservice.searchUsers(user);
      Loader.hideLoader();
      if (err) {
        this.setState({
          message: "Error: " + err,
          isUserType: false
        });
      } else {
        if (response.data !== null) {
          this.setState({
            ...this.state,
            client: response.data,
            data: response.data,
            isUserType: false
          });
        } else {
          this.setState({
            ...this.state,
            message: "No Data",
            isUserType: false
          });
        }
        this.setState({
          ...this.state.search,
          search: {
            companyNames: "",
            emails: "",
            pan: "",
            mobiles: "",
          },
        });
      }
    } else {
      Loader.hideLoader();
    }
  }

  async createDropdownList(value) {
    if (value === "") {
      this.setState({
        dropdownHidden: true,
      });
    } else {
      document.getElementById("loader").classList.remove("hide");
      let { response, err } = await registercorrectionservice.getCompanyNames(
        value
      );
      document.getElementById("loader").classList.add("hide");
      if (err) {
        this.setState({
          message: "Error: " + err,
        });
      } else if (response && response.data.err) {
        this.setState({
          message: "Error: " + response.data.err,
        });
      } else {
        let allCompany = [];
        if (response.data.length > 0) {
          for (let i = 0; i < response.data.length; i++) {
            allCompany.push(
              <li
                onClick={this.assignClientValue.bind(
                  this,
                  response.data[i].companyName
                )}
                value={response.data[i].companyName}
                key={response.data[i].userId}
                id={response.data[i].companyName}
                style={{ cursor: "pointer", marginLeft: "7px" }}
              >
                {response.data[i].companyName}
              </li>
            );
          }
        }
        this.setState({
          dropdownHidden: false,
          allCompanyDropdown: allCompany,
        });
      }
    }
  }

  assignClientValue(value) {
    this.setState({
      search: {
        ...this.state.search,
        companyNames: value,
      },
      dropdownHidden: true,
    });
  }

  assignClientKeyPress(e) {
    var nodes = document.getElementById("search_list").childNodes;
    if (nodes.length > 0) {
      if (e.keyCode === 40) {
        if (this.clientCount < nodes.length - 1) {
          this.clientCount++;
        }

        for (let i = 0; i < nodes.length; i++) {
          if (this.clientCount === i) {
            nodes[i].style.background = "lightblue";
          } else {
            nodes[i].style.background = "";
          }
        }
      } else if (e.keyCode === 38) {
        if (this.clientCount > 0) {
          this.clientCount--;
        }

        for (let i = 0; i < nodes.length; i++) {
          if (this.clientCount === i) {
            nodes[i].style.background = "lightblue";
          } else {
            nodes[i].style.background = "";
          }
        }
      } else if (e.keyCode === 13) {
        e.preventDefault();
        this.assignClientValue(nodes[this.clientCount].id);
      }
    }
  }

  async onUpdateUsers() {
    let data = {
      client: {
        userId: this.state.client.userId,
        userVerified: this.state.client.userVerified,
        companyName: this.state.client.companyName,
        email: this.state.client.email,
        panNo: this.state.client.panNo,
        mobile: this.state.client.mobile,
        userType: this.state.client.userType,
      },
      isUserType: this.state.isUserType,
      updatedClient: this.state.updatedClient,
    };

    let { response, err } = await registercorrectionservice.updateUsers(data);

    if (err) {
      this.setState({
        error: err,
      });
    } else if (response && response.data.err) {
      this.setState({
        ...this.state,
        error: response.data.err,
        updatedClient: {},
      });
    } else {
      this.setState({
        ...this.state,
        message: response.data.msg,
        updatedClient: {},
        error: "",
        showModel: "",
      });
    }
  }

  async increaseToken(e, userId, email) {
    let data = {
      userId,
      email,
    };

    let { response, err } = await registercorrectionservice.increaseToken(data);

    if (err) {
      this.setState({
        message: err,
      });
    } else if (response && response.data.err) {
      this.setState({
        ...this.state,
        // client: response.data.userVerificationExpires,
        // data: response.data,
        error: response.data.err,
      });
    } else {
      this.setState({
        ...this.state,
        message: response.data.msg,
        showModel: "",
      });
    }
  }

  onClear() {
    this.setState({
      client: {
        companyName: "",
        email: "",
        panNo: "",
        mobile: "",
      },
      showModel: "",
      updatedClient: {},
      validationErrors: "",
    });
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let {
      companyName,
      email,
      panNo,
      mobile,
      userType,
      userVerified,
    } = this.state.client;
    let { companyNames, emails, pan, mobiles } = this.state.search;
    let {
      companyNameError,
      emailError,
      panError,
      mobileError,
      userTypeError,
      panNoError,
    } = this.state.validationErrors;
    const datatable = (
      <DataTable
        className="data-table"
        keyField="id"
        pagination={{
          enabled: false,
          pageLength: 20,
          type: "long",
        }}
        width="100%"
        headers={this.state.headers}
        data={this.state.data.length > 0 ? this.state.data : []}
        noData="No records!"
      />
    );

    return (
      <Fragment>
        <div className="container">
          <div className="row">
            <div className="col-sm-12  mt-2 pt-2">
              <div className="col-sm-12 card   pt-3 rounded-0">
                <h4 className="text-uppercase text-center mt-0 mb-0 text-primary">
                  {" "}
                  Registration Correction{" "}
                </h4>
                <div className="text-center text-muted">
                  <small> Fill one or multiple fields</small>
                </div>
                <hr className="mt-3" />

                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group fg-animate">
                      <span id="loader" className="loading hide"></span>
                      <label htmlFor="Name">Company Name</label>
                      <input
                        required
                        type="text"
                        value={companyNames}
                        className="form-control"
                        onChange={this.handleSearchInputChange}
                        onKeyDown={this.assignClientKeyPress.bind(this)}
                        name="companyNames"
                        autoComplete="off"
                        style={{ position: "relative" }}
                      />
                      <div
                        className="search-redult-div"
                        hidden={this.state.dropdownHidden}
                      >
                        <ul type="none" className="pl-0" id="search_list">
                          {this.state.allCompanyDropdown}
                        </ul>
                      </div>
                    </div>
                    <span className="error-msg">{companyNameError}</span>
                  </div>

                  <div className="col-sm-3">
                    <div className="form-group fg-animate">
                      <span id="loader" className="loading hide"></span>
                      <label htmlFor="Name">Email</label>
                      <input
                        required
                        type="text"
                        value={emails}
                        className="form-control"
                        name="emails"
                        onChange={this.handleSearchInputChange}
                        autoComplete="off"
                        style={{ position: "relative" }}
                      />
                    </div>
                    <span className="error-msg">{emailError}</span>
                  </div>

                  <div className="col-sm-3">
                    <div className="form-group fg-animate">
                      <span id="loader" className="loading hide"></span>
                      <label htmlFor="Name">PAN</label>
                      <input
                        required
                        type="pan"
                        value={pan}
                        className="form-control"
                        name="pan"
                        onChange={this.handleSearchInputChange}
                        maxLength="10"
                        autoComplete="off"
                        style={{ position: "relative" }}
                      />
                    </div>
                    <span className="error-msg">{panError}</span>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group fg-animate">
                      <span id="loader" className="loading hide"></span>
                      <label htmlFor="Name">Mobile</label>
                      <input
                        required
                        type="mobiles"
                        value={mobiles}
                        className="form-control"
                        name="mobiles"
                        onChange={this.handleSearchInputChange}
                        autoComplete="off"
                        maxLength="10"
                        style={{ position: "relative" }}
                      />
                    </div>
                    <span className="error-msg">{mobileError}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <button
                      className="btn btn-info btn-md rounded-0 col-sm-2 offset-sm-10 mb-3 search"
                      disabled={!(companyNames || emails || pan || mobiles)}
                      onClick={this.onSearch}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.message && (
          <div className="alert alert-success ml-3">{this.state.message}</div>
        )}
        {this.state.error && (
          <div className="alert alert-error ml-3">{this.state.error}</div>
        )}

        <div
          style={
            this.state.showModel ? { display: "none" } : { display: "block" }
          }
          className="col-sm-12 "
        >
          <div className="row mt-2">
            <div className="col-sm-12">{datatable}</div>
          </div>
        </div>

        {this.state.showModel &&
        this.state.client &&
        this.state.client.userId &&
        !this.state.message ? (
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="col-sm-12 card pt-3 rounded-0">
                  <h5 className="text-uppercase text-center mt-0 mb-0 text-dark">
                    Edit Registeration{" "}
                  </h5>
                  <hr className="mt-1" />

                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group fg-animate">
                        <span id="loader" className="loading hide"></span>
                        <label htmlFor="Name">Company Name</label>
                        <input
                          required
                          type="text"
                          value={companyName}
                          className="form-control"
                          onChange={this.handleInputChange}
                          name="companyName"
                          autoComplete="off"
                          style={{ position: "relative" }}
                        />
                      </div>
                      <span className="error-msg">{companyNameError}</span>
                    </div>

                    <div className="col-sm-4">
                      <div className="form-group fg-animate">
                        <span id="loader" className="loading hide"></span>
                        <label htmlFor="Name">PAN</label>
                        <input
                          required
                          type="text"
                          // value={pan}
                          className="form-control"
                          name="panNo"
                          onChange={this.handleInputChange}
                          value={panNo || ""}
                          maxLength="10"
                          autoComplete="off"
                          style={{ position: "relative" }}
                        />
                      </div>
                      <span className="error-msg">{panNoError}</span>
                    </div>

                    <div className="col-sm-4">
                      <div className="form-group fg-animate">
                        <span id="loader" className="loading hide"></span>
                        <label htmlFor="Name">Email</label>
                        <input
                          required
                          type="text"
                          value={email || ""}
                          className="form-control"
                          name="email"
                          onChange={this.handleInputChange}
                          autoComplete="off"
                          style={{ position: "relative" }}
                        />
                      </div>
                      <span className="error-msg">{emailError}</span>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group fg-animate">
                        <span id="loader" className="loading hide"></span>
                        <label htmlFor="Name">Mobile</label>
                        <input
                          required
                          type="text"
                          // value={mobile}
                          className="form-control"
                          name="mobile"
                          onChange={this.handleInputChange}
                          value={mobile || ""}
                          autoComplete="off"
                          maxLength="10"
                          style={{ position: "relative" }}
                        />
                      </div>
                      <span className="error-msg">{mobileError}</span>
                    </div>

                    <div className="col-sm-4">
                      <DropDown
                        label="User Type"
                        name="userType"
                        value={userType}
                        onChange={this.handleInputChange}
                        list={ddUsersTypess}
                        valProp="value"
                        textProp="name"
                      />
                      <span className="error-msg">{userTypeError}</span>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-sm-12">
                      <button
                        className="btn btn-success rounded-0"
                        type="button"
                        onClick={() =>
                          this.onUpdateUsers(
                            this.state.client.userId,
                            this.state.client.userVerified
                          )
                        }
                      >
                        Update
                      </button>
                      <span>&nbsp;</span>
                      <button
                        className="btn btn-default rounded-0"
                        type="button"
                        onClick={this.onClear}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}
export default RegisterCorrection;
